export const updateClientConstants = {
	GET_CLIENT: 'GET_CLIENT',
	SET_CLIENT: 'SET_CLIENT',
	UPDATE_CLIENT: 'UPDATE_CLIENT',
	CLIENT_UPDATED: 'CLIENT_UPDATED',
	UPDATE_ADDRESSES: 'UPDATE_ADDRESSES',
	UPDATE_CLIENT_BENEFIT: 'UPDATE_CLIENT_BENEFIT',
	CLIENT_BENEFIT_UPDATED: 'CLIENT_BENEFIT_UPDATED',
}
